module.exports = __webpack_public_path__ + "static/media/DF78F918-96DF-403D-940F-84FF0A5607DF.7771d435.JPG";